import React from "react";
import Title from "../../../components/Title/Title";

const AreaChair2027page = () => {
    return (
        <div>
            <Title>Area Chairs</Title>
            <p>[COMING SOON]</p>
        </div>
    )
}

export default AreaChair2027page
